import Title from "App/Component/ui/title/Title";
import { RESET_STATE_HEADER } from "./helpers";
import BundleHeader from "./BundleHeader";
import BundleKunjungan from "./BundleKunjungan";
import { useState } from "react";
import BundleDetailHeader from "./BundleDetailHeader";
import useReloadTableDetailHeader from "./hooks/useReloadTableDetailHeader";

export default function BundleWrapper() {
	const [formDataBundle, setFormDataBundle] = useState(RESET_STATE_HEADER);
	const [showModal, setShowModal] = useState(false);

	const {
		resetPagination,
		setNewData,
		pagination,
		onPrevious,
		onNext,
		handleClickPageNumber,
		handleChangeLimit,
		loading,
		formFilter,
		setFormFilter,
	} = useReloadTableDetailHeader();

	const handleSelectBundle = () => {
		setShowModal(!showModal);
	};

	return (
		<>
			{showModal && (
				<BundleHeader
					showModal={showModal}
					setShowModal={setShowModal}
					formDataBundle={formDataBundle}
					setFormDataBundle={setFormDataBundle}
				/>
			)}

			<Title title="Satu Sehat - Bundle Encounter" />

			<BundleKunjungan
				handleSelectBundle={handleSelectBundle}
				formDataBundle={formDataBundle}
				setFormDataBundle={setFormDataBundle}
				setNewDataDetail={setNewData}
			/>

			{formDataBundle.id_bundle !== "" ? (
				<>
					<BundleDetailHeader
						formDataBundle={formDataBundle}
						setFormDataBundle={setFormDataBundle}
						resetPagination={resetPagination}
						setNewData={setNewData}
						pagination={pagination}
						onPrevious={onPrevious}
						onNext={onNext}
						handleClickPageNumber={handleClickPageNumber}
						handleChangeLimit={handleChangeLimit}
						loading={loading}
						formFilter={formFilter}
						setFormFilter={setFormFilter}
					/>
				</>
			) : (
				<></>
			)}
		</>
	);
}
